import { render, staticRenderFns } from "./SwatchesWrapper.vue?vue&type=template&id=f3ad8e34"
import script from "./SwatchesWrapper.vue?vue&type=script&lang=js"
export * from "./SwatchesWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports